import { render, staticRenderFns } from "./AdditionalInformationModalContent.vue?vue&type=template&id=0de59540&"
import script from "./AdditionalInformationModalContent.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformationModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports